import CatererPerLeg from "./CatererPerLeg";

export default CatererPerLeg;